import { gql } from "@apollo/client";

const SAVE_VISITA_TELE_ENFERMERIA_CP = gql`
    mutation saveVisitaTeleEnfermeriaCP($input: AddVisitaTeleEnfermeriaCPInput!){
        saveVisitaTeleEnfermeriaCP(input: $input) {
            idTeleEnfermeriaCP
            idVisita
        }
    }
`;

export default SAVE_VISITA_TELE_ENFERMERIA_CP;

export const adaptAddVisitaTeleEnfermeriaCPInput = (data) => ({
  idTeleEnfermeriaCP: data?.idTeleEnfermeriaCP,
  idVisita: data?.idVisita,
  apetito: data?.apetito,
  gradoDolor: data?.gradoDolor,
  catarsis: !!data?.catarsis,
  obsCatarsis: data?.obsCatarsis,
  diuresis: !!data?.diuresis,
  cantidad: data?.cantidad,
  obsDiuresis: data?.obsDiuresis,
  horaCama: data?.horaCama,
  sentimiento: data?.sentimiento,
  preocupacion: data?.preocupacion,
  repasoIndicacion: data?.repasoIndicacion,
  ampliarConcepto: data?.ampliarConcepto
});